<script setup lang="ts">
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';

const userStore = useUserStore();
const { me } = storeToRefs(userStore);
</script>

<template>
  <RouterLink to="/topup" class="bal" v-if="me">
    <span class="value">{{ me.balance_tokens }}</span>
    <span class="unit">т.</span>
  </RouterLink>
  <span class="bal bal--skeleton" v-else />
</template>

<style scoped>
.bal {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  padding: 6px 12px;
  border-radius: var(--r-full);
  background: var(--accent-soft);
  color: var(--accent);
  font-weight: 600;
}
.value { font-variant-numeric: tabular-nums; }
.unit { font-size: var(--fs-sm); opacity: 0.8; }
.bal--skeleton { width: 60px; height: 28px; background: var(--bg-overlay); }
</style>
